module.exports = {"130132001":"城区街道","130132100":"槐阳镇","130132101":"殷村镇","130132102":"南佐镇","130132103":"宋曹镇","130132104":"南因镇","130132105":"姬村镇","130132106":"北褚镇","130132107":"马村镇","130132201":"东张乡","130132202":"赵同乡","130132204":"苏村乡","130132205":"苏阳乡","130132206":"北正乡","130132207":"前仙乡","130132208":"黑水河乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130132.json
// module id = 74
// module chunks = 0